import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d733dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "otp-section" }
const _hoisted_2 = { class: "otp-section-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "otp-section-title" }, "ยืนยันตัวตน", -1))
const _hoisted_4 = {
  key: 0,
  class: "otp-section-text"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ใส่รหัสยืนยันตัวตน 6 หลัก ที่ถูกส่งไปที่ ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "otp-section-text"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ใส่รหัสยืนยันตัวตน 6 หลัก ที่ถูกส่งไปที่ ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "otp-box-inner" }
const _hoisted_11 = { class: "otp-section-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ส่งรหัสใหม่")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "footer-ref-text" }
const _hoisted_15 = ["value"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.level === 'L1')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" เบอร์โทรศัพท์ปัจจุบัน: " + _toDisplayString(_ctx.mobileNumber), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.level !== 'L1')
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.newMobileNumber), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "otp-box-container",
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleFocusInput && _ctx.handleFocusInput(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOtpList(), (digit, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(['otp-box', { 'otp-box__active': _ctx.isInputFocus && (Math.min(_ctx.otp.length, 5) === index) }])
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(digit), 1)
          ], 2))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", {
          class: _normalizeClass(['footer-resend-text', { 'footer-resend-text__clickable': _ctx.isResendReady }]),
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.handleSendOtp && _ctx.handleSendOtp(...args)))
        }, [
          _hoisted_12,
          (!_ctx.isResendReady)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " " + _toDisplayString(_ctx.getDisplayTime(_ctx.timer)), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("p", _hoisted_14, "Ref: " + _toDisplayString(_ctx.refCodeNew), 1)
      ]),
      _createElementVNode("input", {
        class: "otp-section-input",
        ref: "otpRef",
        value: _ctx.otp,
        type: "number",
        inputmode: "numeric",
        pattern: "[0-9]*",
        autocomplete: "one-time-code",
        onInput: _cache[2] || (_cache[2] = (...args) => (_ctx.handleUpdateOtp && _ctx.handleUpdateOtp(...args))),
        onKeydown: _cache[3] || (_cache[3] = (...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args))),
        onBlur: _cache[4] || (_cache[4] = (...args) => (_ctx.handleBlur && _ctx.handleBlur(...args)))
      }, null, 40, _hoisted_15)
    ])
  ]))
}